import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Headroom from 'react-headroom';
import Img from 'gatsby-image'
import LoanMonsterLogo from '../SVG/LoanMonsterLogo'
import { useMonsterLookingOverFixed } from '../HOOKS/useMonsterLookingOverFixed'
import Burger from '../SVG/Burger'
import BurgerClose from '../SVG/BurgerClose'
import HeaderNav from '../HeaderNav';
import GatsbyLink from '../GatsbyLink';
import { isIE11 } from '../../utils/helpers'
import './Header.scss';

const isClient = typeof window !== 'undefined';
class Header extends Component {
  state = {
    contactActive: false,
    navActive: false,
    menuHeight: `100vh`,
    isIE: false,
  }
  
  componentDidMount() {
    if(window) {
      window.addEventListener('resize', this.handleResize);
      if (isIE11) {
        console.info('IE <= 11 detected.')
        this.setState({isIE: true})
      }
    }
  }

  /* Small function to remove the nav-open
   * On a window resize.
   */
  handleResize = () => {
    if (window.innerWidth > 1080) {
      if(isClient) {
        let childrenDomElements = document.querySelectorAll('.children');
        for (let i = 0; i < childrenDomElements.length; i++) {
          if (childrenDomElements[i].classList.contains('open')) {
            childrenDomElements[i].classList.remove('open')
          }
        }
        if (document.body.classList.contains('nav-open')) {
          this.toggleNav();
        }
      }
    }
    
    /**
     * Recalculate our menu height on screen resizing.
     * Potentially debounce this method due to performance issues.
     */
    if (window) {
      this.state.menuHeight !== window.innerHeight ? this.setState({menuHeight: window.innerHeight}) : null
    }
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  toggleNav = event => {
    const { navActive } = this.state;
    if (event) event.preventDefault();
    if (!navActive) {
      if (isClient && window.innerWidth < 800) {
        document.body.classList.add('nav-open');
      }
      this.setState({
        contactActive: false,
        navActive: true,
        menuHeight: isClient && window.innerHeight,
      });
    } else {
      if (isClient) {
        document.body.classList.remove('nav-open');
      }
      this.setState({ navActive: false });
    }
  };

  closeAll = event => {
    if (event) event.preventDefault();
    if (isClient) {
      document.body.classList.remove('nav-open');
    }
    this.setState({
      navActive: false,
    });
  };

  render() {
    const {
      navActive,
      menuHeight,
      isIE
    } = this.state;
    const {
      data,
    } = this.props;
    const {
      abovePrimaryNavigation,
      primaryNavigation,
      siteSettings,
      wordpressWpSettings
    } = data;
    const { options } = siteSettings
    const { baseUrl } = wordpressWpSettings;
    const { items: navItems } = primaryNavigation
    const { items: aboveNavItems } = abovePrimaryNavigation
    
    return (
      <Headroom disable disableInlineStyles={true} pinStart={50}>
        <header className={options.invertHeaderColours ? 'invert' : ''}>
          <div className="header-main">
            <div className="inner">
              <div className="nav">
                <CollapsibleMenuButton navActive={navActive} toggleNav={this.toggleNav} isIE={isIE} />
                <GatsbyLink className="logo" to="/"><LoanMonsterLogo width={240} height={55}/></GatsbyLink>
                <nav style={{height: menuHeight}} className={`nav-inner${navActive ? ' active' : ''} primary-navigation`}>
                  <div className="bg-block" />
                  <HeaderNav active={navActive} className="navigation" navItems={navItems} baseUrl={baseUrl} toggleNav={this.toggleNav} />
                  <PrimaryNavAction />
                </nav>
                <nav className={`above-navigation`}>
                  {/* Pass in an empty function that simply returns null to toggle nav */}
                  <HeaderNav className="navigation" navItems={aboveNavItems} baseUrl={baseUrl} toggleNav={() => () => {return null}} />
                </nav>
              </div>
            </div>
          </div>
        </header>
      </Headroom>
    );
  }
}

const CollapsibleMenuButton = props => {
  const { toggleNav, navActive, isIE } = props
  return (
    <div className="controls">
      <button
        type="button"
        className={`control-nav icon-hamburger ${navActive ? 'active' : ''}`}
        onClick={toggleNav}
        aria-label="Toggle Menu"
      >
        {!isIE && <Burger className={`burger ${navActive ? 'active' : ''}`} />}
        {isIE && !navActive && <Burger className={`burger ${navActive ? 'active' : ''}`} />}
        {isIE && navActive && <BurgerClose className={`burger burger-closed`} />}
        </button>
    </div>
  )
}

const PrimaryNavAction = () => {
  const image = useMonsterLookingOverFixed()
  return (
    <div className="primary-nav-action">
      <div className="image-wrapper">
        <Img fixed={image} />
      </div>
      <a href="tel:9336 4489">
      <div className="call-text">
        <p>CALL US ON 9336 4489</p>
      </div>
      </a>
    </div>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        primaryNavigation: wordpressWpApiMenusMenusItems(slug: { eq: "primary-navigation" }) {
          items {
            title
            url
            classes
            slug: object_slug
            object_id
            target
            children: wordpress_children {
              title
              url
              classes
              object_id
              slug: object_slug
              target
            }
          }
        }
        abovePrimaryNavigation: wordpressWpApiMenusMenusItems(slug: { eq: "above-navigation" }) {
          items {
            title
            url
            classes
            slug: object_slug
            object_id
            target
            children: wordpress_children {
              title
              url
              classes
              object_id
              slug: object_slug
              target
            }
          }
        }
        siteSettings: wordpressAcfOptions(options: {}) {
          options {
            navigationAbovePrimaryMenu
            socialLinksHeader
            contactNumberHeader
            invertHeaderColours
            showSearchIconInMainNavigation
            locations {
              addressDisplay
              email
              phone
            }
          }
        }
        wordpressWpSettings {
          siteUrl
        }
      }
    `}
    render={data => <Header data={data} {...props} />}
  />
)
